import type { FaireProductEntity } from "../../entity_types/product";

export const p_9f88rz2t7k: FaireProductEntity = {
  token: "p_9f88rz2t7k",
  type: "product",
  name: "Mineral Point - Smoky Quartz - Gold Wire Wrapped Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/bf9cb71a407c6cd8cb7679e78b9c2da492341f9b2b3b32ce136639f21024a35e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/becb96cc874191f98a328d67342d354aca75ffcdc7a5a33c5fc5826ac39be4b9.png",
    "https://cdn.faire.com/fastly/4e21c7e4cbf4ed8e6c4beacd16ff854569e8e4691a8e58ac48338ea53db3637a.jpeg",
    "https://cdn.faire.com/fastly/d7fbc5211e60bfefd032cd4c5adc318c428fb7a94d137d48dbc3846971d5e65b.jpeg",
    "https://cdn.faire.com/fastly/62f4aafedc6648e460e0606ed4d370f9bf17293d1dc83fd1ebd855e5a3d2f48e.jpeg",
  ],
  priceDollars: 18.2,
  description:
    "With a distinctive style, these stud earrings feature polished, double-pointed smoky quartz stones set in a minimal gold setting, offering strong visual appeal and a unique addition to any assortment.\n\n18K gold plating over Brass\n5x more gold than the standard plating\nTarnish-Free - Long-lasting protective coating that safeguards your jewelry\nNatural smoky quartz stone\nLength: 16mm\nWidth: 4mm\nButterfly back",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:48.885Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
